import { useQuery } from '@apollo/client';

import {
  type GetVitaJobRoleSuggestionsQuery,
  type GetVitaJobRoleSuggestionsQueryVariables,
  GetVitaJobRoleSuggestionsDocument,
} from '@xing-com/crate-lebenslauf-graphql';

type JobRoleSuggestions = {
  data?: GetVitaJobRoleSuggestionsQuery;
  refetch: (value: string) => void;
};

export const useJobRoleSuggestions = (value: string): JobRoleSuggestions => {
  const getQueryVariables = (
    text: string
  ): GetVitaJobRoleSuggestionsQueryVariables => ({
    text,
    consumer: 'loggedout.web.lebenslauf.jobrole',
  });
  const { data, refetch: refetchSuggestions } =
    useQuery<GetVitaJobRoleSuggestionsQuery>(
      GetVitaJobRoleSuggestionsDocument,
      {
        variables: getQueryVariables(value || ''),
        skip: !value,
      }
    );
  const refetch = (value: string): void => {
    refetchSuggestions(getQueryVariables(value));
  };

  return { data, refetch };
};
